import styles from './FJUsageDetail.module.less';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJDropdownNew from '../../../components/FJDropDown/FJDropdownNew.jsx';
import cionNewUrl from '../../../../assets/base64/cion-new.js';
import { useRef, forwardRef, useImperativeHandle } from 'react';

const FJUsageDetailTwo = forwardRef((props, ref) => {
    const { list, renderTrigger, totalCredit, offsetLeft, offsetTop, placement = 'topCenter' } = props;

    const dropDownRef = useRef(null);

    useImperativeHandle(ref, () => ({
        // 开放给父组件的方法
        closeDropdown: () => {
            dropDownRef.current?.hide();
        },
        openDropdown: () => {
            dropDownRef.current?.show();
        },
    }));

    const _renderOverlay = config => {
        return (
            <div className={styles.detail_box} onClick={e => e.stopPropagation()} ref={config.ref}>
                <div className={styles.title}>{FJLocalStore._('usage-details')}</div>
                {list.map((itemList, index) => (
                    <ul className={styles.usage_item} key={index}>
                        {itemList.map((item, index) => (
                            <li key={index}>
                                <div className={styles.label}>{FJLocalStore._(item.label)}</div>
                                <div className={styles.value}>{item.value}</div>
                            </li>
                        ))}
                    </ul>
                ))}

                <div className={styles.footer}>
                    <div className={styles.normal_text}>{FJLocalStore._('total')}</div>
                    <div className={styles.credit}>
                        <img src={cionNewUrl} alt='' />
                        <div className={styles.normal_text}>
                            {Math.floor(totalCredit * 1000) / 1000}
                            {/* &nbsp;
                            {FJLocalStore._('credit')} */}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <FJDropdownNew
            isTopLayer={true}
            renderTrigger={renderTrigger}
            useAnchorBody
            placement={placement}
            triggerDisplay='flex'
            trigger='hover'
            renderOverlay={_renderOverlay}
            ref={dropDownRef}
            offsetLeft={offsetLeft}
            offsetTop={offsetTop}
            active
        />
    );
});

export default FJUsageDetailTwo;
